export default "__VITE_ASSET__sAmcpyxk__"